import { useState } from 'react'
import Checkbox from '@mui/joy/Checkbox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import List from '@mui/joy/List'
import ListItem from '@mui/joy/ListItem'
import Typography from '@mui/joy/Typography'
import _ from 'lodash'
import { Box } from '@mui/joy'
import { Tooltip } from '@mui/material'
import { grey } from '@mui/material/colors'

export const NetworkSelectListV2 = ({
    label,
    networks,
    selectedNetworks,
    onChange,
    featureFlags,
    isVideo,
}) => {
    const [networkState, setNetworkState] = useState(() => {
        let selectedMap = _.flatMap(
            selectedNetworks,
            (obj) => obj.canonicalName
        )
        let initMap = {}
        networks.forEach((network) => {
            initMap[network.canonicalName] = {
                selected: selectedMap.includes(network.canonicalName),
                obj: network,
            }
        })
        return initMap
    })

    const handleChange = ({ target }) => {
        networkState[target.value].selected = target.checked
        setNetworkState({ ...networkState })
        let data = _.pickBy(networkState, (obj) => obj.selected === true)
        onChange(_.map(data, (item) => item.obj))
    }

    return (
        <div role="group">
            <Typography level="body-md">{label}</Typography>
            <List
                sx={{
                    minWidth: 420,
                    maxWidth: 600,
                    gap: '0.75rem',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    '--ListItem-radius': '8px',
                    '--ListItemDecorator-size': '32px',
                }}
            >
                {networks
                    .filter(
                        (nw) =>
                            nw.canonicalName !== 'youtube_short' ||
                            (isVideo &&
                                featureFlags.includes('youtube_publish'))
                    )
                    .map((network) => (
                        <Tooltip
                            key={network.canonicalName}
                            title={network?.tooltip}
                        >
                            <ListItem
                                sx={{
                                    p: 0,
                                    boxShadow: 'sm',
                                    width: '45%',
                                }}
                            >
                                <Checkbox
                                    label={
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                px: '0.5rem',
                                                gap: '0.25rem',
                                            }}
                                        >
                                            {networkState[network.canonicalName]
                                                .selected ? (
                                                <CheckBoxIcon
                                                    htmlColor={grey[300]}
                                                    fontSize="small"
                                                />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    fontSize="small"
                                                    htmlColor={grey[600]}
                                                />
                                            )}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {network.icon}
                                                {network.displayName}
                                            </div>
                                        </Box>
                                    }
                                    disableIcon={true}
                                    value={network.canonicalName}
                                    onChange={handleChange}
                                    checked={
                                        networkState[network.canonicalName]
                                            .selected
                                    }
                                    sx={{
                                        '& .MuiCheckbox-action': {
                                            border: 'none',
                                        },
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                />
                            </ListItem>
                        </Tooltip>
                    ))}
            </List>
        </div>
    )
}
